import { createModalContext } from "shared/components/vero-modal";

export const {
  Context: FraudIndicatorsModalContext,
  Provider: FraudIndicatorsModalProvider,
  useModalContext: useFraudIndicatorsModal,
} = createModalContext();
